import { SplitHeaderLayout } from "@/App/Equities/mobile/layout"
import { RootPath } from "@/App/Equities/mobile/paths"
import {
  FeaturedInstruments,
  InstrumentsTable,
  TRADE_PAGE_LOCATORS,
} from "@/App/Equities/shared/components"
import {
  setSearchValue,
  useSearchResults,
} from "@/App/Equities/shared/services/instruments"

import { AppHeader } from "../appHeader"
import { InstrumentPage } from "../instrumentPage"

const SearchResults = () => {
  const instruments = useSearchResults()
  return (
    <InstrumentsTable
      instruments={instruments}
      data-testid={TRADE_PAGE_LOCATORS.search}
    />
  )
}

export const Trade = () => (
  <SplitHeaderLayout
    data-testid={TRADE_PAGE_LOCATORS.main}
    routePattern={RootPath.trade}
    childRoutes={[
      {
        path: RootPath.tradeInstrument.routePattern,
        element: <InstrumentPage />,
      },
    ]}
    header={<AppHeader />}
    searchControllerOptions={{
      searchResultComponent: <SearchResults />,
      setSearchValue: setSearchValue,
      "data-testid": TRADE_PAGE_LOCATORS.search,
    }}
  >
    <FeaturedInstruments />
  </SplitHeaderLayout>
)
